"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slaConfigureTranslations = {
    "en": {
        minSlaValue: "Min value is 5 seconds",
        maxSlaValue: "Max value is 1200 seconds",
        infoText: "Use the SLA feature to easily see if you are meeting your queuing time goals. The\n        first service level is colored yellow when exceeded, the second service level is\n        automatically set to double the first and is colored red when exceeded.",
        configureSla: "Configure SLA (Service Level Agreement)",
        slaLabel1: "1st SLA",
        slaLabel2: "2nd SLA",
        slaApply: "APPLY",
        slaCancel: "CANCEL",
        seconds: "seconds",
    },
    "de": {
        infoText: "Mit der SLA-Funktion k\u00F6nnen Sie leicht erkennen, ob Sie Ihre Ziele f\u00FCr die Wartezeit erreichen. Die\n        erste Dienstebene wird bei einer \u00DCberschreitung gelb gef\u00E4rbt, die zweite Dienstebene wird\n        automatisch auf das Doppelte der ersten eingestellt und bei einer \u00DCberschreitung rot gef\u00E4rbt.",
        minSlaValue: "Der min. Wert beträgt 5 Sekunden",
        slaLabel2: "2. SLA",
        configureSla: "SLA (Service Level Agreement) konfigurieren",
        slaLabel1: "1. SLA",
        slaApply: "ANWENDEN",
        seconds: "Sekunden",
        maxSlaValue: "Der max. Wert beträgt 1 200 Sekunden",
        slaCancel: "ABBRECHEN",
    },
    "nl": {
        infoText: "Gebruik de SLA-functie om eenvoudig te zien of u uw wachtrijdoelen haalt Het\n        eerste service level wordt geel gekleurd wanneer het wordt overschreden, het tweede service level wordt\n        automatisch op dubbel het eerste gezet en wordt rood gekleurd wanneer overschreden.",
        minSlaValue: "De minimale waarde is 5 seconden",
        slaLabel2: "2e SLA",
        configureSla: "SLA (Service Level Agreement) configureren",
        slaLabel1: "1e SLA",
        slaApply: "TOEPASSEN",
        seconds: "seconden",
        maxSlaValue: "De maximale waarde is 1200 seconden",
        slaCancel: "ANNULEER",
    },
    "it": {
        infoText: "Usa la funzione SLA per vedere subito se stai raggiungendo i tuoi obiettivi sui tempi in coda. Il\n        primo livello di servizio \u00E8 giallo se superato, il secondo livello di servizio \u00E8\n        automaticamente impostato pari al doppio del primo ed \u00E8 rosso quando superato.",
        minSlaValue: "Valore minimo: 5 secondi",
        slaLabel2: "2o SLA",
        configureSla: "Configura SLA (livelli di servizio)",
        slaLabel1: "1o SLA",
        slaApply: "APPLICA",
        seconds: "secondi",
        maxSlaValue: "Valore massimo: 1200 secondi",
        slaCancel: "ANNULLA",
    },
    "fr": {
        infoText: "Utilisez la fonction ENS pour facilement voir si vous avez atteint vos objectifs concernant le temps en file d'attente. Le\n        premier niveau de service est en jaune lorsqu'il y a d\u00E9passemet, le deuxi\u00E8me niveau de service est\n        automatiquement d\u00E9fini pour doubler le premier et est en rouge lorsqu'il y a d\u00E9passement.",
        minSlaValue: "La valeur minimale est de 5 secondes",
        slaLabel2: "2e ENS",
        configureSla: "Configurer l'ENS (entente de niveau de service)",
        slaLabel1: "1re ENS",
        slaApply: "APPLIQUER",
        seconds: "secondes",
        maxSlaValue: "La valeur maximale est de 1200 secondes",
        slaCancel: "ANNULER",
    },
    "es": {
        infoText: "Utilice la funci\u00F3n de Acuerdo de Nivel de Servicio para ver f\u00E1cilmente si usted cumple con sus objetivos de tiempo de espera en cola. El\n        primer nivel de servicio aparece en color amarillo cuando es sobrepasado, el segundo nivel de servicio est\u00E1\n        autom\u00E1ticamente ajustado para duplicar el primero y aparece en color rojo cuando es sobrepasado.",
        minSlaValue: "El valor mínimo es 5 segundos",
        slaLabel2: "2. Segundo Acuerdo de Nivel de Servicio",
        configureSla: "Configure el ANS (Acuerdo de Nivel de Servicio)",
        slaLabel1: "1. Primer Acuerdo de Nivel de Servicio ",
        slaApply: "APLICAR",
        seconds: "segundos",
        maxSlaValue: "El valor máximo es 1200 segundos",
        slaCancel: "CANCELAR",
    },
    "ja": {
        infoText: "SLA\u6A5F\u80FD\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u30AD\u30E5\u30FC\u6642\u9593\u306E\u76EE\u6A19\u3092\u9054\u6210\u3057\u3066\u3044\u308B\u304B\u7C21\u5358\u306B\u78BA\u8A8D\u3067\u304D\u307E\u3059\u3002\u7B2C1\u30B5\u30FC\u30D3\u30B9\u30EC\u30D9\u30EB\u3092\u8D85\u3048\u305F\u5834\u5408\u306F\n        \u9EC4\u8272\u3067\u8868\u793A\u3055\u308C\u3001\u81EA\u52D5\u7684\u306B\u7B2C2\u30B5\u30FC\u30D3\u30B9\u30EC\u30D9\u30EB\u304C\n        \u7B2C1\u30B5\u30FC\u30D3\u30B9\u30EC\u30D9\u30EB\u306E2\u500D\u306B\u8A2D\u5B9A\u3055\u308C\u307E\u3059\u3002\u8D85\u3048\u305F\u5834\u5408\u306F\u8D64\u8272\u3067\u8868\u793A\u3055\u308C\u307E\u3059\u3002",
        minSlaValue: "最小は5秒",
        slaLabel2: "第2SLA",
        configureSla: "SLA（サービスレベル合意）を設定する",
        slaLabel1: "第1SLA",
        slaApply: "適用",
        seconds: "秒",
        maxSlaValue: "最大は1200秒",
        slaCancel: "キャンセル",
    },
    "en-GB": {
        infoText: "Use the SLA feature to see easily if you are meeting your queuing time goals. The\n        first service level is coloured yellow when exceeded, the second service level is\n        automatically set to double the first and is coloured red when exceeded.",
        minSlaValue: "Min value is 5 seconds",
        slaLabel2: "2nd SLA",
        configureSla: "Configure SLA (Service Level Agreement)",
        slaLabel1: "1st SLA",
        slaApply: "APPLY",
        seconds: "seconds",
        maxSlaValue: "Max value is 1200 seconds",
        slaCancel: "CANCEL",
    },
    "ru": {
        minSlaValue: "Минимальное значение 5 секунд",
        maxSlaValue: "Максимальное значение 1200 секунд",
        infoText: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0421\u0423\u041E \u0444\u0438\u0447\u0443, \u0447\u0442\u043E\u0431\u044B \u043B\u0435\u0433\u043A\u043E \u043F\u043E\u043D\u0438\u043C\u0430\u0442\u044C, \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u0435\u0442 \u043B\u0438 \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u043C\n        \u0446\u0435\u043B\u044F\u043C. \u041F\u0435\u0440\u0432\u044B\u0439 \u0443\u0440\u043E\u0432\u0435\u043D\u044C \u043F\u0440\u0438 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u0438 \u043B\u0438\u043C\u0438\u0442\u0430 \u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0441\u044F \u0436\u0435\u043B\u0442\u044B\u043C, \u0432\u0442\u043E\u0440\u043E\u0439 \u043F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E \u0432\n        \u0434\u0432\u0430 \u0440\u0430\u0437\u0430 \u0431\u043E\u043B\u044C\u0448\u0435 \u043F\u0435\u0440\u0432\u043E\u0433\u043E \u0438 \u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0441\u044F \u043A\u0440\u0430\u0441\u043D\u044B\u043C.",
        configureSla: "Сконфигурировать СУО (Cоглашение об Уровне Обслуживания)",
        slaLabel1: "1й СУО",
        slaLabel2: "2й СУО",
        slaApply: "ПРИМЕНИТЬ",
        slaCancel: "ОТМЕНИТЬ",
        seconds: "сек",
    },
};
